import {get} from 'helpers';
import * as selectors from 'store';

// allow using selectors in reducers
export function select(store) {
  return next => action => {
    const state = store.getState();
    next({
      ...action,
      select: (path, options) => {
        const selector = get(selectors, path);
        if (typeof selector != 'function') {
          throw new Error(`Selector "${path}" not found`);
        }
        return selector(state, options);
      }
    });
  }
}
